import { AppointmentsNew } from '../../../../../../../types/AppointmentNewTypes';

export const getAppointmentType = (appointment: AppointmentsNew) => {
  if (appointment.isFirstTimeVisit) return 'FV';
  if (appointment.isReevaluation) return 'RE';
  return 'FU';
};
